module.exports = __webpack_public_path__ + "img/jichu4.679c41c5.png";